import type { CreateInvoiceLineInput } from "@/lib/api";
import {
  toDocumentLinePayload,
  type DocumentLineDraft,
} from "@/features/document-lines/productDetails";

export interface InvoiceLineDraft extends DocumentLineDraft {
  uid: string;
}

export function toInvoiceLinePayload(
  lines: InvoiceLineDraft[],
): CreateInvoiceLineInput[] {
  if (lines.length === 0) throw new Error("Add at least one line.");
  return lines.map((line, index) => toDocumentLinePayload(line, index));
}
